import { Params } from "../../interface/core.interface";

export class GetProductCategories {
  static readonly type = "[ProductCategories] Get";
}

export class SelectProductCategories {
  static readonly type = "[SelectProductCategories] Get";
  constructor(public payload?: any) {}
}

export class ClearSelectCategory {
  static readonly type = "[ClearSelectCategory] Delete";
}
